<!-- 按钮组（拟态tab切换的另一个视觉样式，没走权限控制，简易版，后续再考虑完善） -->
<script>
export default {
  name: 'AnsoButtonGroup',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 默认需要有父元素来限制长度（每个按钮自动分配），不会根据按钮文字长度自行撑出，如果为自适应，则是根据按钮文字自行撑开父元素长度
    isAdaptive: {
      type: Boolean,
      default: true,
    },
    // 是否为二级按钮组样式，二级采用镂空视觉
    plain: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: '',
    },
    /**
     * [{
     *  label: 'tab名称',
     *  value: 'tab标识'
     * }]
     */
    btns: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(config) {
      this.$emit('input', config.value)
      this.$emit('click', config)
    },
    generateBtns() {
      return this.btns.map((item) => {
        return (
          <div
            key={item.value}
            class={['btn-item', { 'active-item': this.value === item.value }]}
            onClick={() => this.handleClick(item)}
          >
            {item.label}
          </div>
        )
      })
    },
  },
  render() {
    return (
      <div
        class={[
          'btn-list',
          this.plain ? 'plain-view' : 'normal-view',
          { adaptive: this.isAdaptive },
        ]}
      >
        {this.generateBtns()}
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
.btn-list {
  .btn-item {
    flex: 1 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: #8c8c8c;
    cursor: pointer;

    &:hover {
      color: #3171f2;
    }
  }

  .active-item {
    color: #3171f2;
  }
}

.normal-view {
  display: flex;
  padding: 3px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;

  .btn-item {
    text-align: center;
    border-radius: 2px;
    line-height: 22px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }

    &:hover {
      color: #3171f2;
    }
  }

  .active-item {
    color: #3171f2;
    background-color: #eaf1fe;
  }
}

// 自适应，根据按钮文案撑出父节点长度
.adaptive {
  display: inline-flex;
  width: fit-content; // 防止父元素设为flex，导致其还会根据父元素长度撑满

  .btn-item {
    padding: 0 12px;
    white-space: nowrap;
  }
}

.plain-view {
  display: inline-flex;
  padding: 0;
  border: 0;

  .btn-item {
    position: relative;
    padding: 0 12px;
    font-size: 12px;
    line-height: 24px;
    border: 1px solid #e5e5e5;

    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      margin-left: -1px;
      border-radius: 0 4px 4px 0;
    }
  }

  .active-item {
    border-color: #3171f2;
    z-index: 1;
  }
}
</style>
